import React from 'react';
import { Card, Col,  Row } from 'react-bootstrap';
import './Projects.css'
import { Link } from 'react-router-dom';

const Projects = () => {
    return (
        <div id='project'>
            <Card className='about-me m-auto mt-5' style={{ width: '90%' }}>
            <Card.Body>
            <p className='section-title'>My Projects </p>
            {/* project-1 */}
              <Row data-aos="zoom-in" data-aos-easing="ease-out-cubic"
        data-aos-duration="1000" className='project-div mt-4'>
                  <Col xs={12} sm={12} md={8}>
                      <p style={{fontFamily:'Montserrat',color:'rgb(90, 89, 89)',fontWeight:'700'}}>SPORTS BIKE</p>
                      <div className='site-links' style={{fontSize:'14px',marginBottom:'20px'}}>
                         <a rel='noreferrer' target="_blank" href="https://github.com/somiyaPrity/Sports-Bike">Client Site Code</a>
                         <a rel='noreferrer' target="_blank" href="https://github.com/somiyaPrity/Sports-bike-server-site">Server Site Code</a>
                         <a rel='noreferrer' target="_blank" href="https://sports-bike-6aaee.web.app/">Live Site</a>
                      </div>
                      <p style={{fontSize:'14px',color:'rgb(90, 89, 89)'}}>
                          <span style={{fontWeight:'700'}}>Technologies Used:</span>
                       React, React Bootstrap, React Hook
                    Form, Material UI, Firebase, Node (Express JS For CRUD
                    operation), React Hook form, MongoDB.
                      </p>
                     
                      <Link to='/sportsBike'><button className="button-cv" >Show Details</button></Link>
                  </Col>
              </Row>
              {/* project-2 */}
              <Row data-aos="zoom-in" data-aos-easing="ease-out-cubic"
        data-aos-duration="1000" className='project-div mt-4'>
                  
                  <Col xs={12} sm={12} md={8}>
                      <p style={{fontFamily:'Montserrat',color:'rgb(90, 89, 89)',fontWeight:'700'}}>APPON RESPONSIVE WEBSIE</p>
                      <div className='site-links' style={{fontSize:'14px',marginBottom:'20px'}}>
                         <a rel='noreferrer' target="_blank" href="https://github.com/somiyaPrity/Apon-responsive-webpage-">Code</a>
                         
                         <a rel='noreferrer' target="_blank" href="https://somiyaprity.github.io/Apon-responsive-webpage-/">Live Site</a>
                      </div>
                      <p style={{fontSize:'14px',color:'rgb(90, 89, 89)'}}>
                          <span style={{fontWeight:'700'}}>Technologies Used:</span>
                          HTML, CSS, Bootstrap, jQuery
                      </p>
                      <p style={{fontSize:'14px'}}>
                      It’s a fully responsive website.
                      </p>
                      <Link to='/appon'><button className="button-cv" >Show Details</button></Link>
                  </Col>
                 
              </Row>
              </Card.Body>
            </Card>
        </div>
    );
};

export default Projects;